import { useState } from 'react';
import { Link } from '@tanstack/react-router';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Thumbs } from 'swiper/modules';
import type { Swiper as SwiperType } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import { formatPublishedAt } from '../../../lib/format-date';
import type { ArticleCardData } from './ArticleCard';
import { SmartImage } from '../../../components/media/SmartImage';
import { CategoryLink } from '../../../components/CategoryLink';

export function PostGallerySlider({ items }: { items: ArticleCardData[] }) {
  const [thumbs, setThumbs] = useState<SwiperType | null>(null);
  return (
    <>
      <Swiper
        modules={[Thumbs]}
        thumbs={{ swiper: thumbs }}
        spaceBetween={0}
        slidesPerView={1}
        className="post_gallery_slider"
      >
        {items.map((item, index) => (
          <SwiperSlide key={item.id}>
            <div className="post_gallery_play">
              <div className="bg-image">
                {/* First slide is the home page LCP element. */}
                <SmartImage
                  media={item.coverMedia}
                  alt={item.title}
                  priority={index === 0}
                  sizes="(max-width: 991px) 100vw, 66vw"
                />
              </div>
              <div className="post__gallery_play_content">
                <div className="post-meta">
                  {item.category && (
                    <div className="meta-categories">
                      <CategoryLink slug={item.category.slug} name={item.category.name} />
                    </div>
                  )}
                  <div className="meta-date"><span>{formatPublishedAt(item.publishedAt)}</span></div>
                </div>
                <h2 className="title">
                  <Link to="/articles/$slug" params={{ slug: item.slug }}>
                    {item.title}
                  </Link>
                </h2>
                <p>{(item.excerpt ?? item.contentText ?? '').slice(0, 100)}</p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="post_gallery_inner_wrap">
        <span className="prev slick-arrow" data-pgi-prev>
          <i className="fal fa-angle-left" />
        </span>
        <Swiper
          modules={[Thumbs, Navigation]}
          watchSlidesProgress
          onSwiper={setThumbs}
          slidesPerView={4}
          spaceBetween={0}
          navigation={{ prevEl: '[data-pgi-prev]', nextEl: '[data-pgi-next]' }}
          breakpoints={{
            0: { slidesPerView: 3 },
            576: { slidesPerView: 4 },
            992: { slidesPerView: 5 },
          }}
          className="post_gallery_inner_slider"
        >
          {items.map((item) => (
            <SwiperSlide key={item.id}>
              <div className="item">
                <SmartImage media={item.coverMedia} alt={item.title} />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <span className="next slick-arrow" data-pgi-next>
          <i className="fal fa-angle-right" />
        </span>
      </div>
    </>
  );
}
